export interface ContentLibraryAccessContext {
  contentLibraryEnabled: boolean;
}

export const canAccessContentLibrary = (ctx: ContentLibraryAccessContext): boolean =>
  ctx.contentLibraryEnabled;
